import type { RutaProd } from "../../../../runtime/rutas";
export default {
  "ruta": "/sistema/cedis/orders/generate",
  "documento": "cedis",
  "acceso": "sesion",
  "filas": [
    "045"
  ],
  "cita": "Areas/CEDIS/Controllers/OrdersController.cs"
} satisfies RutaProd;
